(() => {
  const fetchPredictiveContent = async (query, endpoint, signal) => {
    const url = new URL(endpoint, location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('section_id', document.querySelector('[data-search-dialog]')?.dataset.predictiveSection || 'storefront-predictive-search');
    url.searchParams.set('resources[limit]', '4');
    url.searchParams.set('resources[limit_scope]', 'each');
    const response = await fetch(url, { signal, headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('Predictive request failed');
    const template = document.createElement('template');
    template.innerHTML = await response.text();
    const content = template.content.querySelector('[data-predictive-content]');
    if (!content) throw new Error('Predictive section missing');
    return content;
  };
  // Match only established collection paths; ignore query/fragment and normalize absolute/local URLs.
  const collectionKey = value => {
    try { return new URL(value, location.origin).pathname.replace(/\/$/, ''); }
    catch (_) { return value; }
  };
  const mergeCollections = (matches, nativeLinks, root, predictive = false) => {
    const remaining = [...nativeLinks];
    const links = matches.map(item => {
      const index = remaining.findIndex(link => collectionKey(link.href) === collectionKey(item.url));
      const link = index >= 0 ? remaining.splice(index, 1)[0] : root.querySelector('[data-online-collection-card]').content.firstElementChild.cloneNode(true);
      if (index < 0) { link.href = item.url; link.querySelector('strong').textContent = item.title; }
      link.dataset.confirmedFitment = 'true';
      if (predictive) { link.setAttribute('role', 'option'); link.setAttribute('aria-selected', 'false'); link.tabIndex = -1; }
      else ['role', 'aria-selected', 'tabindex', 'id'].forEach(name => link.removeAttribute(name));
      return link;
    });
    return [...links, ...remaining];
  };
  const renderCollections = region => {
    if (!region) return;
    const links = mergeCollections(region.directoryMatches || [], region.nativeLinks || [], region);
    region.querySelector('[data-collection-results]').replaceChildren(...links);
    region.hidden = !links.length;
    refreshEmpty(region.closest('.search-page'));
  };
  const refreshEmpty = page => { if(!page)return;const empty=page.querySelector('[data-native-empty]');if(empty)empty.hidden=page.dataset.directoryState==='pending'||page.dataset.directoryState==='matched'||Boolean(page.querySelector('[data-search-collections]:not([hidden])')); };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-storefront-search]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const input = root.querySelector('[data-search-input]');
      const list = root.querySelector('[data-search-results]');
      const status = root.querySelector('[data-search-status]');
      let timer, request, version = 0, active = -1;
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', list.id);
      input.setAttribute('aria-expanded', 'false');
      const options = () => [...list.querySelectorAll('[role="option"]')];
      const close = () => {
        clearTimeout(timer);
        request?.abort();
        version++;
        list.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        active = -1;
        status.textContent = '';
      };
      root.closeSearch = close;
      const search=()=>{
        const query=input.value.trim();if(!query||input.composing)return close();
        request?.abort();const current=++version;request=new AbortController();
        let nativeNodes=[],nativeDone=false,nativeFailed=false,directoryDone=false,directoryFailed=false,model,contacts=[],online=[];
        const paint=()=>{
          if(current!==version)return;
          const selectedHref=options()[active]?.getAttribute('href');
          const group=document.createElement('div');group.className='search-contact-fitments';group.setAttribute('role','group');group.setAttribute('aria-label',root.dataset.fitmentHeading);
          if(contacts.length){const heading=document.createElement('h3');heading.className='search-contact-fitments__heading';heading.textContent=root.dataset.fitmentHeading;group.append(heading);if(root.dataset.fitmentNote){const text=document.createElement('p');text.className='search-contact-fitments__text';text.textContent=root.dataset.fitmentNote;group.append(text);}const cards=document.createElement('div');cards.className='fitment-list';contacts.forEach(item=>{const card=window.MegakronFitments.createCard(item,{...model.labels,contactLabel:root.dataset.fitmentStatus||model.labels.contactLabel});const link=card.querySelector('a');link.setAttribute('role','option');link.setAttribute('aria-selected','false');link.tabIndex=-1;link.setAttribute('aria-label',item.title+'. '+(root.dataset.fitmentStatus||model.labels.contactLabel)+'. '+model.labels.quoteLabel);cards.append(card);});group.append(cards);}
          const renderedNative = nativeNodes.map(node => node.cloneNode(true));
          let collections = renderedNative.find(node => node.matches?.('[data-resource-type="collections"]'));
          if (online.length) {
            if (!collections) {
              collections = document.createElement('div'); collections.className = 'search-result-group'; collections.dataset.resourceType = 'collections'; collections.setAttribute('role', 'group');
              const heading = document.createElement('h3'); heading.className = 'search-result-group__heading'; heading.textContent = root.querySelector('[data-online-collection-heading]').textContent;
              collections.setAttribute('aria-label', heading.textContent); collections.append(heading); renderedNative.unshift(collections);
            }
            const links = mergeCollections(online, [...collections.querySelectorAll('[role="option"]')], root, true);
            collections.querySelectorAll('[role="option"]').forEach(link => link.remove()); collections.append(...links);
          }
          const nativeEmpty=renderedNative.flatMap(node=>node.querySelectorAll?[...node.querySelectorAll('.search-empty')]:[]).concat(renderedNative.filter(node=>node.matches?.('.search-empty')));
          nativeEmpty.forEach(empty=>empty.hidden=!directoryDone||contacts.length>0||online.length>0);
          list.replaceChildren(...(contacts.length?[group]:[]),...renderedNative);
          const items=options();active=selectedHref?items.findIndex(item=>item.getAttribute('href')===selectedHref):-1;
          items.forEach((option,index)=>{option.id=input.id+'-option-'+index;option.setAttribute('aria-selected',String(index===active));});
          if(active>=0)input.setAttribute('aria-activedescendant',items[active].id);else input.removeAttribute('aria-activedescendant');
          list.hidden=!(items.length||(nativeDone&&directoryDone&&!nativeFailed));input.setAttribute('aria-expanded',String(!list.hidden));
          const announcement=items.length?(root.dataset.found.includes('__COUNT__')?root.dataset.found.replaceAll('__COUNT__',items.length):items.length+' '+root.dataset.found):'';
          const pending=!directoryDone?root.dataset.directoryLoading:'';
          const errors=(nativeFailed?root.dataset.error+' ':'')+(directoryFailed?root.dataset.directoryError:'');
          status.textContent=[announcement,!nativeDone?root.dataset.loading:'',pending,errors].filter(Boolean).join(' ');
          if(!items.length&&nativeDone&&directoryDone&&!nativeFailed&&!directoryFailed)status.textContent=list.textContent.trim();
        };
        list.hidden=true;active=-1;input.removeAttribute('aria-activedescendant');input.setAttribute('aria-expanded','false');status.textContent=root.dataset.loading;
        fetchPredictiveContent(query,root.dataset.endpoint,request.signal).then(content=>{nativeNodes=[...content.childNodes];nativeDone=true;paint();}).catch(error=>{if(error.name==='AbortError')return;nativeDone=true;nativeFailed=true;paint();});
        Promise.resolve().then(()=>window.MegakronFitments.loadDirectory(root.dataset.directoryUrl)).then(value=>{model=value;const matches=window.MegakronFitments.match(model.entries,query);contacts=matches.filter(item=>!item.online);online=matches.filter(item=>item.online);directoryDone=true;paint();}).catch(()=>{directoryDone=true;directoryFailed=true;paint();});
      };
      input.addEventListener('input', () => {
        close();
        if (input.value.trim() && !input.composing) timer = setTimeout(search, 220);
      });
      input.addEventListener('compositionstart', () => { input.composing = true; close(); });
      input.addEventListener('compositionend', () => { input.composing = false; timer = setTimeout(search, 220); });
      input.addEventListener('keydown', (event) => {
        if (event.isComposing) return;
        const items = options();
        if (event.key === 'Escape' && !list.hidden) { event.preventDefault(); event.stopPropagation(); close(); return; }
        if (list.hidden || !items.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          active = active < 0 ? (event.key === 'ArrowDown' ? 0 : items.length - 1) : (active + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
          items.forEach((option, index) => option.setAttribute('aria-selected', String(index === active)));
          input.setAttribute('aria-activedescendant', items[active].id);
          items[active].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && active >= 0) {
          event.preventDefault();
          location.assign(items[active].href);
        } else if (event.key === 'Tab') close();
      });
      root.querySelector('form').addEventListener('submit', close);
      root.addEventListener('focusout', (event) => { if (event.relatedTarget && !root.contains(event.relatedTarget)) close(); });
      const onOutside = (event) => { if (!root.contains(event.target)) close(); };
      document.addEventListener('pointerdown', onOutside);
      root.disposeSearch = () => { close(); document.removeEventListener('pointerdown', onOutside); };
    });
    scope.querySelectorAll('[data-contact-fitments]').forEach(async root=>{
      if(root.dataset.ready||!root.dataset.query.trim())return;root.dataset.ready='true';
      const page=root.closest('.search-page'),status=root.querySelector('[data-contact-status]'),region=root.querySelector('[data-contact-region]');
      let disposed=false;root.disposeContactFitments=()=>{disposed=true;};page.dataset.directoryState='pending';refreshEmpty(page);status.hidden=false;status.textContent=root.dataset.directoryLoading;
      try{const model=await window.MegakronFitments.loadDirectory(root.dataset.directoryUrl);if(disposed||!root.isConnected)return;const matches=window.MegakronFitments.match(model.entries,root.dataset.query);const contacts=matches.filter(item=>!item.online);const collections=page.querySelector('[data-search-collections]');collections.directoryMatches=matches.filter(item=>item.online);renderCollections(collections);const labels={...model.labels,contactLabel:root.dataset.fitmentStatus||model.labels.contactLabel};root.querySelector('[data-contact-results]').replaceChildren(...contacts.map(item=>window.MegakronFitments.createCard(item,labels)));region.hidden=!contacts.length;page.dataset.directoryState=contacts.length?'matched':'none';status.hidden=true;}
      catch(_){if(disposed||!root.isConnected)return;page.dataset.directoryState='failed';status.textContent=root.dataset.directoryError;}
      refreshEmpty(page);
    });
    scope.querySelectorAll('[data-search-collections]').forEach(async (region) => {
      if (region.dataset.ready || !region.dataset.query.trim()) return;
      region.dataset.ready = 'true';
      const request = new AbortController();
      region.disposeCollections = () => request.abort();
      try {
        const content = await fetchPredictiveContent(region.dataset.query, region.dataset.endpoint, request.signal);
        if (request.signal.aborted || !region.isConnected) return;
        const links = [...content.querySelectorAll('[data-resource-type="collections"] [role="option"]')];
        if (!links.length) return;
        links.forEach(link => {
          ['role', 'aria-selected', 'tabindex', 'id'].forEach(name => link.removeAttribute(name));
          link.querySelector('.search-result__kind').textContent = region.dataset.collectionLabel;
        });
        region.nativeLinks = links;
        renderCollections(region);
      } catch (_) {}
    });
    const dialog = scope.querySelector('[data-search-dialog]');
    if (dialog && !dialog.dataset.ready) {
      dialog.dataset.ready = 'true';
      dialog.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !event.defaultPrevented) { event.preventDefault(); dialog.close(); } });
      dialog.querySelector('[data-close-search]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        dialog.querySelector('[data-storefront-search]').closeSearch();
        document.documentElement.classList.remove('search-is-open');
        dialog.searchTrigger?.focus();
      });
    }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-open-search]');
    const dialog = document.querySelector('[data-search-dialog]');
    if (!link || !dialog?.showModal || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    dialog.searchTrigger = link;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('search-is-open');
    dialog.querySelector('[data-search-input]').focus();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelector('[data-search-dialog]')?.close();
    event.target.querySelectorAll('[data-storefront-search]').forEach(root => root.disposeSearch?.());
    event.target.querySelectorAll('[data-search-collections]').forEach(region => region.disposeCollections?.());
    event.target.querySelectorAll('[data-contact-fitments]').forEach(root=>root.disposeContactFitments?.());
  });
  document.addEventListener('shopify:section:select', (event) => {
    const dialog = event.target.querySelector('[data-search-dialog]');
    if (dialog && !dialog.open) { dialog.showModal(); document.documentElement.classList.add('search-is-open'); }
  });
  document.addEventListener('shopify:section:deselect', (event) => event.target.querySelector('[data-search-dialog]')?.close());
})();
